import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var UpNextIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 25 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#up-next__a)",
                            children: [
                                _jsx("path", {
                                    d: "M17.5 10c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                                }),
                                _jsx("path", {
                                    d: "M19.5 16h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zM7.5 6c.55 0 1-.45 1-1V4h7c.55 0 1-.45 1-1s-.45-1-1-1h-7V1c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z"
                                }),
                                _jsx("path", {
                                    d: "M8.5 21h-4c-.55 0-1-.45-1-1V9h20V5c0-1.66-1.34-3-3-3h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1 .45 1 1v2h-18V5c0-.55.45-1 1-1h.38c.55 0 1-.45 1-1s-.45-1-1-1H4.5c-1.65 0-3 1.35-3 3v15c0 1.65 1.35 3 3 3h4c.55 0 1-.45 1-1s-.45-1-1-1z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "up-next__a",
                                children: _jsx("path", {
                                    transform: "translate(.5)",
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
UpNextIcon.isCarinaIcon = true;
export default UpNextIcon;
